const CHANGES = [
  {
    title: 'Zero-hours contracts',
    desc: 'Staff can ask for guaranteed hours, reasonable notice of shifts and pay for cancelled ones.',
    year: '2027',
  },
  {
    title: 'Unfair dismissal from 6 months',
    desc: 'Protection starts at six months instead of two years, so casual probation exits get risky.',
    year: 'Jan 2027',
  },
  {
    title: 'Sick pay from day one',
    desc: 'Statutory sick pay starts on the first day of illness, for every employee, with no earnings threshold.',
    year: 'Apr 2026',
  },
  {
    title: 'Fire and rehire',
    desc: 'Dismissing staff to force through worse terms becomes automatically unfair in most cases.',
    year: 'Jan 2027',
  },
  {
    title: 'Day-one family leave',
    desc: 'Paternity and ordinary parental leave become day-one rights, with no waiting period to serve.',
    year: 'Apr 2026',
  },
];

export default function LawStrip() {
  return (
    <section className="lawstrip container">
      <div className="lawstrip__inner">
        <p className="lawstrip__text">
          Are you ready for the biggest change to UK employment law in a generation,{' '}
          <a
            className="lawstrip__accent"
            href="https://www.acas.org.uk/employment-rights-act-2025"
            target="_blank"
            rel="noopener noreferrer"
          >
            the Employment Rights Act 2025
          </a>
          ?
        </p>
        <div className="lawstrip__examples">
          {CHANGES.map((change) => (
            <div className="lawstrip__example" key={change.title}>
              <div className="lawstrip__example-title">{change.title}</div>
              <div className="lawstrip__example-desc">{change.desc}</div>
              <span className="lawstrip__example-year">{change.year}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
